import Model from "./base/model";

class Action extends Model {
  resourceName() {
    return "actions";
  }

  fields() {
    return {
      action: "",
      description: "",
    };
  }
}

export default new Action();
